const theme = {
    // colors
    primaryColor: "red",

    // border
    borderColor1: "#d2d2d2",
    borderColor2: "#efefef",

    // text colors
    textDark: "#333",
    textBlack: "#000",

    // text colors
    textBlackMain: "#111111",
    textBlackHover: "#000000",
    textBlacklight: "#535353",
    textGrayMain: "#888888",
    textRed: "#e30000",
    textRedDark: "#c00000",

    modalHeaderColor: "#f5f5f5",
    subMenuHoverBgColor: "rgba(17, 17, 17, .05)",

    // responsive breakpoints
    breakpoints: {
        sm_min: 576,
        sm_max: 575,

        md_min: 768,
        md_max: 767,

        lg_min: 992,
        lg_max: 991,

        xl_min: 1200,
        xl_max: 1199,
    },

    // responsive breakpoints
    responsiveBreakpoints: {
        min_xs: "576px",
        max_xs: "575px",

        min_sm: "576px",
        max_sm: "575px",

        min_md: "768px",
        max_md: "767px",

        min_lg: "992px",
        max_lg: "991px",

        min_xl: "1200px",
        max_xl: "1199px",

        min_xxl: "1400px",
        max_xxl: "1399px",
    }
};

export default theme;
